import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  sessions: {
    nurseryBranchId: null,
    items: [],
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}